import axios from "axios";
import { base_URL } from "../config/config";

/**
 * Media-type helpers that are safe for presigned URLs. A presigned S3 URL looks
 * like `https://bucket.s3.../video.mp4?X-Amz-Signature=...`, so checking the raw
 * string with `.endsWith(".mp4")` fails — strip the query string first.
 */
export function isYouTubeUrl(url) {
  return (
    typeof url === "string" &&
    (url.includes("youtube.com") || url.includes("youtu.be"))
  );
}

export function isMp4Url(url) {
  if (typeof url !== "string") return false;
  return url.split("?")[0].toLowerCase().endsWith(".mp4");
}

export function isVideoUrl(url) {
  return isYouTubeUrl(url) || isMp4Url(url);
}

/**
 * Exchanges stored S3 image/video URLs for short-lived presigned URLs so the
 * private fmv-data bucket can be read at original quality on preview pages.
 * Non-S3 URLs (YouTube, external) come back unchanged. Falls back to the
 * original URLs on failure so media still attempts to render. Order preserved.
 */
export async function getPresignedUrls(urls) {
  const list = (urls || []).filter(Boolean);
  if (list.length === 0) return [];
  try {
    const res = await axios.post(`${base_URL}/api/hotels/presign-images`, {
      urls: list,
    });
    return res?.data?.urls || list;
  } catch {
    return list;
  }
}
